import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { filter, Subject, take } from 'rxjs';
import { MenuItem } from 'src/app/models';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  animations: [
    trigger('sidebarAnimation', [
      state('closed', style({
        transform: 'translateX(-100%)', // Hide sidebar off the left
      })),
      state('open', style({
        transform: 'translateX(0)', // Show sidebar fully
      })),
      transition('closed <=> open', [
        animate('300ms ease-in-out'), // Smooth transition
      ]),
    ])
  ]
})
export class SidebarComponent implements OnInit {
  @Input() menu: MenuItem[] = [];
  @Input() expandedParents: number[] = [];
  @Input() isHandheld: boolean = false;
  @Input() currentRoute?: string;
  @Input() isOpen: boolean = false;

  @Output() didNavigate = new EventEmitter();


  navItems: { class: string, icon: string }[] = [];

  constructor() { }

  ngOnInit(): void {

  }


}
